var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 0.25C3.83065 0.25 0.25 3.8629 0.25 8.25C0.25 12.6694 3.83065 16.25 8.25 16.25C12.6371 16.25 16.25 12.6694 16.25 8.25C16.25 3.8629 12.6371 0.25 8.25 0.25ZM8.25 14.7016C4.66935 14.7016 1.79839 11.8306 1.79839 8.25C1.79839 4.70161 4.66935 1.79839 8.25 1.79839C11.7984 1.79839 14.7016 4.70161 14.7016 8.25C14.7016 11.8306 11.7984 14.7016 8.25 14.7016ZM9.60484 11.3468C9.60484 10.6048 8.99194 9.99194 8.25 9.99194C7.47581 9.99194 6.89516 10.6048 6.89516 11.3468C6.89516 12.121 7.47581 12.7016 8.25 12.7016C8.99194 12.7016 9.60484 12.121 9.60484 11.3468ZM6.95968 4.54032L7.18548 8.92742C7.18548 9.12097 7.37903 9.28226 7.57258 9.28226H8.89516C9.08871 9.28226 9.28226 9.12097 9.28226 8.92742L9.50806 4.54032C9.50806 4.31452 9.34677 4.12097 9.12097 4.12097H7.34677C7.12097 4.12097 6.95968 4.31452 6.95968 4.54032Z",
    fill: "#FFC107"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAlert);
export default __webpack_public_path__ + "static/media/warning-alert.a0d12346.svg";
export { ForwardRef as ReactComponent };